module.exports = __webpack_public_path__ + "assets/heiban.92cbc99d.svg";